import { runtimeConfig } from './runtimeConfig';

export const api = {
  API_URL: runtimeConfig.API_URL,
  IMAGE_SERVER_URL: runtimeConfig.IMAGE_SERVER_URL,
};
